<template>
  <div class="admin-section">
    <h3>Admin Analytics Dashboard</h3>
    
    <StatsCards :devices="devices" :users="users" />

    <!-- Device Analytics -->
    <div class="section-title">📱 Device Analytics</div>
    <div class="analytics-grid">
      <PopularDevicesChart :devices="devices" />
      <OSDistributionChart :devices="devices" />
    </div>

    <!-- User Analytics -->
    <div class="section-title">👥 User Analytics</div>
    <div class="analytics-grid">
      <TopUsersChart :devices="devices" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '@/firebase'
import { COLORS, FONTS } from '@/styles/brand'
import StatsCards from './analytics/StatsCards.vue'
import PopularDevicesChart from './analytics/PopularDevicesChart.vue'
import OSDistributionChart from './analytics/OSDistributionChart.vue'
import TopUsersChart from './analytics/TopUsersChart.vue'

const devices = ref([])
const users = ref([])

const loadData = async () => {
  try {
    const devicesSnapshot = await getDocs(collection(db, 'devices'))
    devices.value = devicesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    
    const usersSnapshot = await getDocs(collection(db, 'users'))
    users.value = usersSnapshot.docs.map(doc => doc.data())
  } catch (error) {
    console.error('Error loading data:', error)
  }
}

onMounted(() => {
  loadData()
})
</script>

<style scoped>
.admin-section {
  margin-bottom: 40px;
}

.admin-section h3 {
  color: v-bind('COLORS.PRIMARY.WHITE');
  font-family: v-bind('FONTS.PRIMARY');
  margin-bottom: 24px;
  font-size: 1.5rem;
}

.analytics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 32px;
}

.section-title {
  color: v-bind('COLORS.PRIMARY.WHITE');
  font-family: v-bind('FONTS.PRIMARY');
  font-size: 1.3rem;
  font-weight: 600;
  margin: 32px 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid v-bind('COLORS.PRIMARY.RED');
}
</style>